import React from 'react'

import { withStyles } from "@material-ui/core/styles";

import IconButton from '@material-ui/core/IconButton'
import Visibility from "@material-ui/icons/Visibility"
import Edit from "@material-ui/icons/Edit"
import Delete from "@material-ui/icons/Delete"
import Table from "components/Table/Table.js"
import Circular from "components/Circular/Circular"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from 'components/CustomButtons/Button.js'
import CustomInput from "components/CustomInput/CustomInput.js"
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CSVReader from 'react-csv-reader';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import ExportCsv from "exportCsv.js";

import { getCondominioById } from "../../services/condominio/condominio";
import { getLockerById } from "../../services/lockers/lockers";

import {
    getAllOperadores,
    getOperadorById,
    saveOperador,
    deleteOperador,
    updateOperador
} from "../../services/operadores/operadores";

import { getLockerRelated } from "../../services/condominio/condominio";
import { createBrowserHistory } from "history";
import './operadores.css';

const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header =>
        header
            .toLowerCase()
            .replace(/\W/g, '_')
}

class Usuarios extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            id: '',
            nome: '',
            cpf: '',
            email: '',
            senha: '',
            telefone: '',
            perfil: '',
            operadorId: '',
            options: [
                {
                    value: "",
                    label: "",
                },
                {
                    value: "gestor",
                    label: "Gestor",
                },
                {
                    value: "operador",
                    label: "Operador",
                },
            ],
            load: true,
            loadSave: false,

            openModal: false,
            openModalDelete: false,
            deleteSelected: undefined,

            data: [],

            showSave: true,

            showValidation: false,

            currentUser: JSON.parse(localStorage.getItem("user")).data,
            emailNotification: false,
            meuLockerApp: false,
            pwaApp: false,

            isAssociate: false,
            condominioId: null,
            allData: [],
            openModalDeleteAll: false
        }

        this.onNovo = this.onNovo.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onEditar = this.onEditar.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onBuscaDados = this.onBuscaDados.bind(this)
        this.handleClickExportCSV = this.handleClickExportCSV.bind(this)
        this.deleteAllData = this.deleteAllData.bind(this)
        this.saveNewData = this.saveNewData.bind(this)
    }

    componentDidMount() {

        this.onBuscaDados()
    }

    handleChange = (perfil) => {
        this.setState({ perfil: perfil.target.value });
    };

    onBuscaDados = () => {

        getAllOperadores(this.props.lockerId, (data) => {



            getLockerRelated(this.props.lockerId, (res) => {
                if (res.length > 0) {
                    this.setState({ isAssociate: true, condominioId: res[0].condominioId });
                }

                if (data.length === 0) {
                    this.setState({ data: [], load: false })
                    return
                }

                const grid = data.map(item => {
                    return [
                        item.name,
                        item.email,
                        item.phone,
                        <>
                            <IconButton aria-label="view" onClick={() => this.onEditar(item)}>
                                <Edit className={this.props.classes.iconView} />
                            </IconButton>
                            <IconButton aria-label="view" onClick={() => this.setState({
                                openModalDelete: true,
                                deleteSelected: item
                            })}>
                                <Delete className={this.props.classes.iconView} />
                            </IconButton>

                            <IconButton aria-label="view" onClick={() => this.onShow(item)}>
                                <Visibility className={this.props.classes.iconView} />
                            </IconButton>
                        </>
                    ]
                })

                this.setState({
                    load: false,
                    data: grid,
                    allData: data
                })
            })
        })

    }

    onNovo = () => {
        this.setState({
            id: '',
            nome: '',
            cpf: '',
            email: '',
            senha: '',
            telefone: '',
            perfil: '',
            operadorId: '',
            emailNotification: false,
            openModal: true,
            showSave: true,
        })
    }

    onCancel = () => {
        this.setState({ openModal: false })
    }

    onDelete = () => {

        if (this.state.deleteSelected !== undefined) {
            deleteOperador(this.state.deleteSelected.id, (data) => {
                this.setState({
                    openModalDelete: false
                });


                this.onBuscaDados();
            })
        }
    }

    deleteAllData = () => {
        const { allData } = this.state;

        this.setState({ load: true, openModalDeleteAll: false });

        allData.forEach((data, index) => {
            deleteOperador(data.id, (deleted) => {
                if (index === allData.length - 1) {
                    this.onBuscaDados();
                }
            })


        });
    }

    onEditar = (item) => {

        this.setState({
            id: item.id,
            nome: item.name,
            cpf: item.cpf,
            email: item.email,
            senha: '',
            telefone: item.phone,
            perfil: item.perfil,
            operadorId: item.operadorId,
            openModal: true,
            showSave: true
        })
    }

    onShow = (item) => {

        this.setState({
            id: item.id,
            nome: item.name,
            cpf: item.cpf,
            email: item.email,
            senha: '',
            telefone: item.phone,
            perfil: item.perfil,
            operadorId: item.operadorId,
            openModal: true,
            showSave: false
        })
    }

    saveNewData = (data) => {
        this.setState({ load: true });

        data.forEach((d, index) => {
            saveOperador({
                name: d.nome ? String(d.nome) : '-',
                email: d.email ? String(d.email) : '-',
                password: d.senha ? String(d.senha) : '-',
                cpf: d.cpf ? String(d.cpf) : '-',
                phone: d.telefone ? String(d.telefone) : '-',
                perfil: d.perfil ? String(d.perfil) : '-',
                operadorId: d.operadorId ? d.operadorId : '-',
                lockerId: this.props.lockerId ? this.props.lockerId : '-',
            }, (res) => {
                if (index == data.length - 1) {
                    this.onBuscaDados()
                }
            })
        });
    }

    onSave = () => {

        this.setState({ loadSave: true })

        if (this.state.id.length === 0) {
            saveOperador({
                name: this.state.nome,
                email: this.state.email,
                password: this.state.senha,
                cpf: this.state.cpf,
                phone: this.state.telefone,
                perfil: this.state.perfil,
                operadorId: this.state.operadorId,                
                lockerId: this.props.lockerId,                
            }, (data) => {

                this.setState({ loadSave: false, openModal: false })
                this.onBuscaDados()
            })
        }
        else {
            updateOperador(
                this.state.id,
                {
                    name: this.state.nome,
                    email: this.state.email,
                    password: this.state.senha.length > 0 ? this.state.senha : undefined,
                    cpf: this.state.cpf,
                    phone: this.state.telefone,
                    perfil: this.state.perfil,
                    operadorId: this.state.operadorId,                     
                    lockerId: this.props.lockerId,                
                },
                (data) => {

                    this.setState({ loadSave: false, openModal: false })
                    this.onBuscaDados()
                }
            )
        }
    }

    handleClickExportCSV = () => {
        let { allData, condominioId } = this.state;

        this.setState({ load: true });

        let documentData = new Promise((resolve, reject) => {
            let data = [];

            getCondominioById(condominioId, (cond) => {
                getLockerById(this.props.lockerId, (locker) => {
                    allData.forEach((d, index) => {
                        data.push({
                            'chave_registro':  d.id,
                            'id_operador': d.operadorId,
                            'nome': d.name ? d.name : '-',
                            'perfil': d.perfil ? d.perfil : '-',
                            'email': d.email ? d.email : '-',
                            'telefone': d.phone ? d.phone : '-',
                            'cpf': d.cpf ? d.cpf : '-',
                            'senha': d.password,
                            'fim': '',
                        });

                        if (index === allData.length - 1) {
                            resolve(data);
                        }
                    });
                });
            });
        });

        documentData.then((completeData) => {
            ExportCsv(completeData);
            this.onBuscaDados();
        })
    }

    render() {
        if (!localStorage.getItem("user")) {
            createBrowserHistory({ forceRefresh: true }).push("/");
        } else {
            createBrowserHistory({ forceRefresh: false }).push(`/`);
        }

        return (

            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    {
                        this.state.load ? <Circular /> :
                            <>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr' }}>
                                    <Button color="primary" disabled={!this.state.isAssociate} onClick={this.onNovo}>Novo operador</Button>
                                    <div></div>
                                    <Button color="default" disabled={!this.state.isAssociate || this.state.allData.length == 0} onClick={this.handleClickExportCSV} style={{ marginRight: '0.5rem' }}>Exportar Operadores</Button>
                                </div>

                                <Table
                                    tableHeaderColor="primary"
                                    tableHead={["Nome", "E-mail", "Telefone", "Ação"]}
                                    tableData={this.state.data}
                                />
                            </>
                    }
                </GridItem>

                <Dialog
                    open={this.state.openModal}
                    onClose={() => { }}
                    aria-labelledby="responsive-dialog-title"
                    fullWidth={true}
                //maxWidth='lg'
                >
                    <DialogTitle id="responsive-dialog-title">{(this.state.showSave) ? ((this.state.id === '') ? 'Novo operador' : 'Editar operador') : ''}</DialogTitle>
                    <DialogContent>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="E-mail"
                                    id="email"
                                    value={this.state.email}

                                    inputProps={{
                                        value: this.state.email,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ email: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>



                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="Senha"
                                    id="senha"
                                    value={this.state.senha}
                                    type="password"
                                    autocomplete="off"
                                    inputProps={{
                                        value: this.state.senha,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ senha: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="ID"
                                    id="operadorId"
                                    value={this.state.operadorId}
                                    type="text"
                                    autocomplete="off"
                                    inputProps={{
                                        value: this.state.operadorId,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ operadorId: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={6}>
                                <TextField
                                    className={this.props.classes.drop}
                                    id="perfil"
                                    select
                                    label="Perfil"
                                    value={this.state.perfil}
                                    onChange={this.handleChange}
                                >
                                    {this.state.options.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                {/* <CustomInput
                                    labelText="Perfil"
                                    id="perfil"
                                    value={this.state.perfil}
                                    type="text"
                                    autocomplete="off"
                                    inputProps={{
                                        value: this.state.perfil,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ perfil: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                /> */}
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Nome"
                                    id="nome"
                                    value={this.state.nome}

                                    inputProps={{
                                        value: this.state.nome,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ nome: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>


                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="CPF"
                                    id="cpf"
                                    value={this.state.cpf}

                                    inputProps={{
                                        value: this.state.cpf,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ cpf: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Telefone Celular"
                                    id="telefone"
                                    value={this.state.telefone}

                                    inputProps={{
                                        value: this.state.telefone,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ telefone: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>
                        </GridContainer>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCancel}>
                            Cancelar
                        </Button>
                        {
                            this.state.showSave ?
                                <Button onClick={this.onSave} color="primary">
                                    Salvar
                            </Button> : undefined
                        }
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDelete}
                    onClose={() => this.setState({ openModalDelete: false, deleteSelected: undefined })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar operador</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar um operador não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDelete: false })} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.onDelete()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDeleteAll}
                    onClose={() => this.setState({ openModalDeleteAll: false })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar Todos os Operadores</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar todos os operadores não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDeleteAll: false })} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.deleteAllData()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.showValidation} autoHideDuration={6000} onClose={() => this.setState({ showValidation: false })}>
                    <MuiAlert onClose={() => this.setState({ showValidation: false })} elevation={6} variant="filled" severity='error'>
                        Você não tem permissão para realizar esta ação
                    </MuiAlert>
                </Snackbar>

            </GridContainer >
        )
    }
}

const styles = theme => ({
    drop: {
        width: "200px !important",
        marginTop: "8px"
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    iconView: {
        color: "gray !important"
    },
    iconViewArrow: {
        color: "white !important",
    },
    buttonIcon: {
        padding: "5px"
    },
    dropdown: {
        right: "1.5%",
        top: "24%",
        position: "absolute"
    },
    removeMarginFromTop: {
        margin: 0
    },
    inputMargin: {
        marginTop: 10
    },

    lockerVinculadoView: {
        display: 'flex',
        flex: 1,
        background: '#f8f8f8',
        marginTop: 10,
        padding: 10,
        borderRadius: 2,
        borderBottomWidth: 1,
        borderBottomColor: '#ECECEC'
    },
    noButtonDeleteLockerUser: {
        padding: 5
    },
    divGrupos: {
        display: 'flex',
        flexDirection: 'row'
    },
    divItemGrupo: {
        width: '50%'
    }
});

export default withStyles(styles)(Usuarios);
